












import { Mixins, Component } from 'vue-property-decorator'
import ButtonBase from '@/components/common/atoms/ButtonBase.vue'
import StudyResultApis from '@/mixins/requests/student/StudyResultApis.vue'

@Component({
  components: {
    ButtonBase,
  },
})
export default class StudentStudyStart extends Mixins(StudyResultApis) {
  private isCompleted = false

  private async mounted() {
    this.isCompleted = await this.getIsCompleted()
  }

  private start() {
    this.$router.push({ name: 'StudentStudy' })
  }
  private showResult() {
    this.$router.push({ name: 'StudentStudyResult' })
  }
}
